<template>
    <div class="pop-up">
        <el-form :model="form" :rules="rules" ref="formPassword" label-width="100px">
            <el-form-item label="原密码：" prop="passWord">
                <Input v-model="form.passWord" autocomplete="new-password" type="password"></Input>
            </el-form-item>
            <el-form-item label="新密码：" prop="newPassword">
                <Input v-model="form.newPassword" autocomplete="new-password" type="password" placeholder="新密码须包含小写字母和数字，且长度不低于6位！" ></Input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="confirmPassword">
                <Input v-model="form.confirmPassword" autocomplete="new-password" type="password"></Input>
            </el-form-item>
        </el-form>
        <div class="btn_box" style="text-align:center;">
            <el-button class="btn_add_canle" @click="close()">取 消</el-button>
            <el-button class="btn_add_sure" @click="submit()" type="primary" :disabled="isDisabled">提 交</el-button>
        </div>
    </div>
</template>
<script>
    import { Form, FormItem, Input, Button } from 'element-ui'
    import Cookies from 'js-cookie'
    // import { encrypt } from 'common/utils/encryption'
    import Axios from '@/api/diyaxios'
    import { JSEncrypt } from 'jsencrypt'
    export default {
        name: 'editPassword',
        props: [],
        data() {
            var validNewPassword = (rule, value, callback) => {
            // 正则表达式：至少包含一个小写字母和一个数字，长度至少为6
            const re = /^(?=.*[a-z])(?=.*\d)[a-z\d]{6,}$/;
            if (value === this.form.passWord) {
                callback(new Error('新密码不能与原密码一致！'));
            } else if (!re.test(value)) {
                callback(new Error('密码必须包含小写字母和数字，且长度不低于6位！'));
            } else {
                callback(); 
            }
        }
            var validConfirmPassword = (rule, value, callback) => {
                if (value != this.form.newPassword) {
                    callback(new Error('两次密码输入不一致！'));
                } else {
                    callback();
                }
            }
            return {
                form: {
                    passWord: '',
                    newPassword: '',
                    confirmPassword: ''
                },
                isDisabled: false,
                rules: {
                    passWord: [
                        { required: true, message: '原密码不能为空', trigger: 'blur' },
                        { min: 6, max: 30, message: '密码位数最少6位！', trigger: 'blur' }
                    ],
                    newPassword: [
                    { required: true, message: '新密码不能为空！', trigger: 'blur' },
                    { validator: validNewPassword, trigger: 'blur' }
                    ],
                    confirmPassword: [
                        { validator: validConfirmPassword, trigger: 'blur' }
                    ]
                }
            }
        },
        watch: {

        },
        components: { Form, FormItem, Input, Button },
        mounted() {

        },
        methods: {
            close() {//默认关闭事件
                this.$emit('close');
            },
            submit() {
                let vm = this;
                // 表单验证
                vm.$refs.formPassword.validate((valid, obj) => {
                    if (valid) {
                        vm.isDisabled = true;
                        Axios.post('/pwd/action/change', {
                            params: {
                                oldPwd: vm.form.passWord,
                                newPwd: vm.form.newPassword,
                                userId: Cookies.get('UserID'),
                            }
                        }, {
                            headers: {
                                "Content-Type": "application/json",
                                userId: Cookies.get('UserID'),
                                token: Cookies.get('token')
                            }
                        }).then(res => {
                            //成功跳转
                            if (res.code == '200') {
                                //成功跳转
                                vm.$emit('ok');

                            } else {
                                vm.isDisabled = false;
                                this.$message({
                                    message: res.errorMsg,
                                    type: "error",
                                    duration: 5 * 1000
                                });
                                return;
                            }
                        }).catch(res => {
                            vm.isDisabled = false;
                            vm.$message({ message: res.res.errorMsg || '修改失败', type: 'error' });
                        });
                    } else {
                        return false;
                    }
                });
            },
            encrypt(str) {
                var jse = new JSEncrypt();
                var public_key = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOSkUOZBS0PLxbXn0MP+UOq7S+83X3ODHqqdVSyuwwqYyoruPHlYgyJGTPrVDuRP7BKgAYE3nUyPP2XaUw9Dbd8CAwEAAQ==';
                jse.setPublicKey(public_key);
                return jse.encrypt(str);
            }

        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/setPassWord.vue